import accompaniment from "./articles/begleitung-von-a-bis-z.json";
import property from "./articles/immobilien-expertennetzwerk.json";
import discovery from "./articles/nordzypern-kennenlernen-ablauf.json";
import company from "./articles/firmengruendung-fachpartner.json";
import banking from "./articles/bankkonto-vorbereitung-begleitung.json";
import moving from "./articles/umzug-nordzypern-preise-ablauf.json";
import investments from "./articles/investments-auf-anfrage.json";

export const EDITORIAL_ARTICLES = [accompaniment, property, discovery, company, banking, moving, investments];
export const editorialForSlug = (slug: string) => EDITORIAL_ARTICLES.find(article => article.slug === slug);

const normalize = (text: string) => text.replace(/\s+/g, " ").trim();
const fields = ["title", "excerpt", "content", "seoTitle", "metaDescription"] as const;
export const articleTranslations = {
  en: Object.fromEntries(EDITORIAL_ARTICLES.flatMap(article => fields.map(field => [normalize(article.de[field]), article.en[field]]))),
  tr: Object.fromEntries(EDITORIAL_ARTICLES.flatMap(article => fields.map(field => [normalize(article.de[field]), article.tr[field]]))),
};
